import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import Typography from '#web-components/components/Typography';

import styles from './Loader.styles';

interface Props {
  className?: string;
  show?: boolean;
  description?: string;
  loaderIcon: React.ReactNode;
  'data-xpath'?: string;
}

const useStyles = makeStyles(styles, { name: 'Loader' });

export default function Loader({
  className, show = true, description, 'data-xpath': dataXPath, loaderIcon,
}: Props) {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <div className={clsx(classes.root, className, !show && classes.hide)} data-xpath={dataXPath}>
      <div className={classes.loaderBox}>
        <div className={classes.whiteStroke} />
        <div className={classes.rotatableUnitOverflow}>
          <div className={classes.rotatableUnit} />
        </div>
        <div className={classes.loaderBorder}>
          <svg width="140" height="140" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill={theme.colors.loaderBackground}
              fillRule="evenodd"
              clipRule="evenodd"
              d={`
             M140 0H0V140H140V0ZM70.0497 5H69.9206C55.9652 5 44.9963 4.99999 36.2479 6.28355C27.4492 7.57448 20.7724
             10.1788 15.4764 15.4767C10.1806 20.7743 7.57632 27.4509 6.28493 36.2492C5 45.0034 5 55.9807 5
             69.9503V70.0794C5 84.0348 4.99999 95.0037 6.28355 103.752C7.57448 112.551 10.1788 119.228 15.4767
             124.524C20.7743 129.819 27.4509 132.424 36.2492 133.715C45.0037 135 55.9815 135 69.9518
             135H70.0794H70.0799C84.035 135 95.0038 135 103.753 133.716C112.552 132.426 119.229 129.821 124.527
             124.523C129.825 119.226 132.428 112.549 133.718 103.751C135 95.0093 135 84.0511 135
             70.1107V70.1106V69.9206V69.9201C135 55.9649 135 44.9962 133.717 36.2479C132.426 27.4493 129.823
             20.7725 124.527 15.4765C119.231 10.1806 112.554 7.5763 103.754 6.28492C94.9985 5 84.0193 5 70.0497
             5ZM16.8909 16.8906C21.7749 12.0048 27.9846 9.51734 36.5382 8.26236C45.1255 7.00244 55.9498 7 70
             7C84.0501 7 94.8753 7.00335 103.464 8.26373C112.018 9.51917 118.229 12.0067 123.113 16.8907C127.997
             21.7748 130.484 27.9845 131.738 36.5382C132.998 45.1255 133 55.9498 133 70C133 84.0503 132.999 94.8736
             131.74 103.461C130.485 112.014 127.999 118.223 123.113 123.109C118.227 127.995 112.016 130.483 103.462
             131.738C94.8745 132.998 84.0502 133 70 133C55.9499 133 45.1265 132.997 36.5396 131.736C27.9864 130.481
             21.7765 127.993 16.8906 123.109C12.0048 118.225 9.51734 112.015 8.26236 103.462C7.00244 94.8745 7 84.0502
             7 70C7 55.9499 7.00335 45.1265 8.26372 36.5396C9.51915 27.9864 12.0067 21.7766 16.8909 16.8906Z`}
            />
          </svg>
        </div>
        <div className={classes.loader}>
          { loaderIcon }
        </div>
      </div>
      {description && (
        <Typography variant="h7" className={classes.description}>
          {description}
        </Typography>
      )}
    </div>
  );
}
